import React, { useContext, useEffect, useState } from 'react';
import { SoundFontPlayer } from '../hooks';
import { useAudioContext } from './AudioContextContext';
const SoundfontContext = React.createContext(null);
export function SoundfontContextProvider({ children, root }) {
    if (useContext(SoundfontContext) != null) {
        throw new Error('SoundfontContextProvider can only be used once');
    }
    const context = {
        fonts: {},
        root: root ?? 'https://storage.googleapis.com/dobolj.hu/soundfonts/percussion'
    };
    return React.createElement(SoundfontContext.Provider, { value: context }, children);
}
export function useSoundFont(name) {
    const audioContext = useAudioContext();
    const context = React.useContext(SoundfontContext);
    if (context == null) {
        throw new Error('No soundfont context');
    }
    const { fonts, root } = context;
    const [soundFont, setSoundFont] = useState();
    if (fonts[name] == null) {
        fonts[name] = SoundFontPlayer.loadName(name, audioContext, root);
    }
    useEffect(() => {
        fonts[name].then(setSoundFont);
    }, [fonts, name]);
    return soundFont;
}
//# sourceMappingURL=SoundfontContext.js.map